import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "flex flex-col gap-0 w-full"
};
const _hoisted_2 = {
  class: "flex flex-col items-center w-full"
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 1,
  class: "flex items-center gap-1"
};
import { computed } from "vue";
import Skeleton from "primevue/skeleton";
import dayjs from "dayjs";
import { useI18n } from "vue-i18n";
export default {
  __name: 'TimeOffDailyCols',
  props: {
    timeOffItems: {
      type: Object,
      required: true
    },
    interval: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const {
      locale
    } = useI18n();
    const formattedDate = computed(() => {
      return dayjs(props.interval, "YYYY.MM.DD", locale.value).format("DD MMM").toUpperCase();
    });
    const dayInitial = computed(() => {
      return dayjs(props.interval, "YYYY.MM.DD", locale.value).format("dd").toUpperCase();
    });
    const isToday = computed(() => {
      return dayjs(props.interval, "YYYY.MM.DD", locale.value).isSame(dayjs(), "day");
    });
    const dayType = computed(() => {
      if (props.timeOffItems?.length > 0) {
        return props.timeOffItems[0]?.timeIntervalValues.find(item => item.id === props.interval)?.dayType;
      } else {
        return null;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["min-w-[100px] h-[40px] flex items-center justify-between border-surface-100 text-xs font-semibold border-r px-1 text-primary-300", {
          '!text-primary-600 !bg-primary-200': isToday.value
        }])
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [__props.isLoading ? (_openBlock(), _createBlock(_unref(Skeleton), {
        key: 0,
        width: "20px",
        height: "10px",
        class: "mb-1"
      })) : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(formattedDate.value), 1))])])], 2), _createElementVNode("div", {
        class: _normalizeClass(["min-w-[100px] h-[28px] flex items-center justify-center border-surface-100 text-sm font-semibold border border-l-0 border-b-0 text-surface-400", {
          '!text-primary-600 !bg-primary-200': isToday.value
        }])
      }, [__props.isLoading ? (_openBlock(), _createBlock(_unref(Skeleton), {
        key: 0,
        width: "20px",
        height: "10px"
      })) : (_openBlock(), _createElementBlock("span", _hoisted_4, [_createTextVNode(_toDisplayString(dayInitial.value) + " ", 1), dayType.value !== 'WORKDAY' && dayType.value !== 'EXTRA_WORKDAY' && dayType.value !== null ? (_openBlock(), _createElementBlock("i", {
        key: 0,
        class: _normalizeClass(["fa-regular", {
          'fa-bed-front': dayType.value === 'WEEKEND',
          'fa-tree-palm': dayType.value === 'HOLIDAY'
        }])
      }, null, 2)) : _createCommentVNode("", true)]))], 2)]);
    };
  }
};